import {useEffect, useReducer} from "react";

/* Usage : const isMobile = useCheckMobileScreen(elem) */

const useCheckMobileScreen = (element: Element): boolean => {

  const mobileBreakpoint: number = 599;

  const initialState = {width: element.clientWidth};

  function reducer() {
    return {width: element.clientWidth}
  }

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const handleWindowSizeChange = () => {
      dispatch();
    }
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [state]);

  return (state.width <= mobileBreakpoint);
}

export default useCheckMobileScreen
